import { APIError } from '@lib/api'
import * as AdAPI from './api'
import { GetUIBankAdResponse } from './types'

export const getUIBankAd = async (type: string) => {
  const response = await AdAPI.getUIBankAd(type)
  if (!response.ok) throw new APIError(response)
  return response.json as GetUIBankAdResponse
}
